import {useEffect} from 'react';

// Backstop for when nothing is actually mid-transition (no `transitionend` will ever fire).
const FALLBACK_DELAY_MS = 300;

// Waits for AnimatedHeight's transition to finish — scrolling mid-transition races its ResizeObserver.
export function useScrollToTopOnError(error: unknown) {
  useEffect(() => {
    if (!error) return;
    const modalBody = document.querySelector<HTMLElement>('[data-slot="modal-body"]');
    if (!modalBody) return;

    const cancel = () => {
      clearTimeout(fallbackId);
      modalBody.removeEventListener('transitionend', handleTransitionEnd);
    };
    const scrollToTop = () => {
      cancel();
      modalBody.scrollTo({top: 0, behavior: 'smooth'});
    };
    const handleTransitionEnd = (event: TransitionEvent) => {
      if (event.propertyName === 'height') scrollToTop();
    };

    modalBody.addEventListener('transitionend', handleTransitionEnd);
    const fallbackId = setTimeout(scrollToTop, FALLBACK_DELAY_MS);

    return cancel;
  }, [error]);
}
